import { LazyImport, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "OwaGroupUtils" */ './lazyIndex');
});
// Delay loaded imports
export var lazyGetGroupDisplayName = new LazyImport(lazyModule, function (m) { return m.getGroupDisplayName; });
export var lazyGetGroupDisplayNameFromTableView = new LazyImport(lazyModule, function (m) { return m.getGroupDisplayNameFromTableView; });
export var lazyIsPrivateUnjoinedGroup = new LazyImport(lazyModule, function (m) { return m.isPrivateUnjoinedGroup; });
export var lazyIsJoinedGroup = new LazyImport(lazyModule, function (m) { return m.isJoinedGroup; });
export var lazyIsGroupOwner = new LazyImport(lazyModule, function (m) { return m.isGroupOwner; });
export { getSelectedGroupId, getGroupId, getGroupIdFromTableViewId } from './utils/getGroupId';
export { default as isGroupSelected } from './utils/isGroupSelected';
//# sourceMappingURL=index.js.map